// Autogenerated file
export const tripSheetInspectionRecordMethodsEnum = {
    InSystem: "InSystem",
    PaperOriginal: "PaperOriginal",
    ExternalSystem: "ExternalSystem",
    Migration: "Migration",
};
export const tripSheetInspectionRecordMethods = [
    { label: "В системе", value: "InSystem" },
    { label: "На бумажном оригинале", value: "PaperOriginal" },
    { label: "Внешняя система", value: "ExternalSystem" },
    { label: "Миграция", value: "Migration" },
];
